export default __webpack_public_path__ + "static/media/tickBox.32bfd279.svg";